module.exports = __webpack_public_path__ + "img/fisherman.9077de7e.png";